import { Threshold, ThresholdKind } from "PFTypes";

import { useMyAccountInfo } from "../../account/use_my_account_info";

export const useThresholds = (kinds: ThresholdKind[] = []): Record<string, Threshold[]> => {
  const {
    data: { thresholds }
  } = useMyAccountInfo();

  return kinds.reduce(
    (result, current) => ({
      ...result,
      [current]: thresholds?.filter((item) => item.kind === current) || []
    }),
    {}
  );
};
